import { on } from "@gr-exports/async/event";
import type { Unset } from "../../event/head";

/**
 *
 */
export const mqOn = <K extends keyof MediaQueryListEventMap>(
  q: MediaQueryList,
  type: K,
  listener: (this: MediaQueryList, ev: MediaQueryListEventMap[K]) => unknown,
): Unset => {
  if (typeof q.addEventListener === "function") return on(q, type, listener);

  /*                 */
  /*                                                                                 */
  /*                                                                                          */
  q.addListener(listener);
  return () => q.removeListener(listener);
  /*               */
};

/**
 *
 *
 *
 *
 *
 *
 */
export const digestMessage = async (
  message: string,
  algo: AlgorithmIdentifier = "SHA-1",
): Promise<string> => {
  /*                                             */
  const hashBuffer = await crypto.subtle.digest(algo, new TextEncoder().encode(message));

  /*                                                        */
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
};
